import { createFileRoute } from '@tanstack/react-router'
import { AuthSsoCallbackPage } from '@/pages/auth/ui/AuthSsoCallbackPage'

export const Route = createFileRoute('/auth/callback')({
  component: AuthSsoCallbackPage,
})
